export default "__VITE_ASSET__52682c23__"